import { useTranslation } from "react-i18next";
import type { ITermBeneficiar } from "store/managementStore";

interface Props {
    beneficiary: ITermBeneficiar;
    hideBody?: boolean;
}

function MergedStatementsMailBody({ beneficiary, hideBody = false }: Props) {
    const [t] = useTranslation();

    // TODO: this should be editable by the user (here and in the settings)
    let body = "";
    if (!hideBody) {
        body = `Bonjour ${beneficiary.name}${beneficiary.surname ? ` ${beneficiary.surname}` : ""},`;
        body += "\n\n";
        body += "Vous pouvez télécharger vos relevés de droits en cliquant sur le lien ci-dessous.";
    }

    const notificationHeader = t("SendEmail.MergedGrossStatementsBodyHeader");
    const buttonLabel = t("SendEmail.MergedGrossStatementsBodyButton");

    // Should match the UI specified in the backend (documents.ts -> documentForDownloadEmailTemplate)
    return (
        <div className="w-full! max-w-[450px]! pointer-events-none select-none py-2!">
            <p className="text-xs! mb-4! whitespace-pre-wrap opacity-50!">{body}</p>
            <div className="p-4! bg-[#FAFAFA]! border-[1px]! border-[#EAEAEA]! rounded-sm!">
                <div className="text-[12px]! text-[#646464]! mb-1!">{notificationHeader}</div>
                <div className="mt-4! text-white px-4! h-[30px] font-poppins text-xs! bg-black rounded-sm inline-flex items-center justify-center">
                    <div style={{ textAlign: "center" }}>
                        <img
                            width="12"
                            height="12"
                            style={{
                                borderRadius: "2px",
                                verticalAlign: "middle",
                            }}
                            src="https://crealo-prod-images.s3.eu-west-3.amazonaws.com/crealo-mail-arrow-right.png"
                            alt=""
                        />
                        {buttonLabel}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MergedStatementsMailBody;
